module.exports = __webpack_public_path__ + "static/assets/babba02d21cab7a3c912e3a8681888d5.png";